import React from 'react';
import PropTypes from 'prop-types';
import {
	SortingState, SelectionState, FilteringState, PagingState, IntegratedFiltering,
	IntegratedPaging, IntegratedSorting,
} from '@devexpress/dx-react-grid';
import {
	Grid, Table, TableHeaderRow, TableSelection, DragDropProvider,
	TableColumnReordering, PagingPanel, TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui'
import DefaultCell from './DefaultCell';


class SimpleTable extends React.PureComponent {
	state = {
		selectedRows: [],
	};


	handleSelect = (sel) => {
		if(!sel.length) {
			return this.setState({selectedRows: []});
		}

		let lastSelected = sel[sel.length-1];
		this.setState({selectedRows: [lastSelected]});

		if(this.props.onRowSelect) {
			this.props.onRowSelect([lastSelected]);
		}
	};


	render() {
		const props = this.props;

		if (!props.rows) {
			return <div />;
		}

		return (
			<Grid
				rows={props.rows}
				columns={props.columns}>
				{!props.hideFilters &&
					<FilteringState
						defaultFilters={props.defaultFilters}
					/>
				}

				{!props.disableSorting &&
				<SortingState
					defaultSorting={this.props.defaultSorting}
				/>
				}

				<SelectionState
					onSelectionChange={this.handleSelect}
					selection={this.state.selectedRows}
				/>
				{!props.disablePaging &&
				<PagingState
					defaultCurrentPage={0}
					defaultPageSize={props.defaultPageSize}
				/>
				}

				{!props.hideFilters && <IntegratedFiltering />}
				{!props.disableSorting && <IntegratedSorting />}
				{!props.disablePaging && <IntegratedPaging />}

				<DragDropProvider />

				<Table
					columnExtensions={props.columnExtensions}
					cellComponent={props.cellComponent}
				/>

				<TableColumnReordering defaultOrder={props.columns.map(column => column.name)}/>

				<TableHeaderRow showSortingControls={!props.disableSorting} />
				{!props.hideFilters && <TableFilterRow showFilterSelector />}
				{!props.disablePaging &&
				<PagingPanel
					pageSizes={[5, 10, 15, 20, 50, 100]}
				/>
				}

				<TableSelection
					selectByRowClick
					highlightSelected
					showSelectionColumn={false}
				/>
			</Grid>
		);
	}
}


SimpleTable.defaultProps = {
	hideFilters: false,
	disablePaging: false,
	disableSorting: false,
	defaultPageSize: 5,
	columnExtensions: [],
	defaultFilters: [],
	defaultSorting: [],
	cellComponent: DefaultCell,
};


SimpleTable.propTypes = {
	columns: PropTypes.array.isRequired,
	onRowSelect: PropTypes.func,
	hideFilters: PropTypes.bool.isRequired,
	defaultFilters: PropTypes.array,
	defaultSorting: PropTypes.array,
	disablePaging: PropTypes.bool.isRequired,
	disableSorting: PropTypes.bool.isRequired,
	columnExtensions: PropTypes.array.isRequired,
	cellComponent: PropTypes.func.isRequired,
};


export default SimpleTable;